import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsActiveGuard } from './_guards/is-active.guard';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard as RoleGuard } from './_guards/role.guard';

const routes: Routes = [
    { path: '', redirectTo: '/main', pathMatch: 'full' },
    { path: 'main',  loadChildren: () => import('./main/main.module').then(m => m.MainModule), canActivate: [AuthGuard, IsActiveGuard, RoleGuard], data: { expectedRole: 2 } },
    { path: 'clientes',  loadChildren: () => import('./clientes/clientes.module').then(m => m.ClientesModule), canActivate: [AuthGuard, IsActiveGuard, RoleGuard], data: { expectedRole: 2 } },
    { path: 'usuarios-admin',  loadChildren: () => import('./usuarios-admin/usuarios-admin.module').then(m => m.UsuariosAdminModule), canActivate: [AuthGuard, IsActiveGuard, RoleGuard], data: { expectedRole: 2 } },
    { path: 'consultas',  loadChildren: () => import('./documents-old/documents.module').then(m => m.DocumentsModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'consultas-new',  loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'productos',  loadChildren: () => import('./productos/productos.module').then(m => m.ProductosModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'pagos',  loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'almacen',  loadChildren: () => import('./almacen/almacen.module').then(m => m.AlmacenModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'almacen/ordenes/:id',  loadChildren: () => import('./almacen-orden/almacen-orden.module').then(m => m.AlmacenOrdenModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'almacenes',  loadChildren: () => import('./stores/stores.module').then(m => m.StoresModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'reports',  loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule), canActivate: [AuthGuard, IsActiveGuard] },
    { path: 'solicitudes/:id',  loadChildren: () => import('./order/order.module').then(m => m.OrderModule), canActivate: [AuthGuard, IsActiveGuard] },
    // {
    //     path: 'lactaciones',
    //     loadChildren: 'app/hist-lactaciones/hist-lactaciones.module#HistLactacionesModule',
    //     canActivate: [RoleGuard],
    //     data: {
    //         expectedRole: 6,
    //         expectedModule: 4
    //     }
    // },
    { path: 'login',  loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
    // { path: 'login',  loadChildren: 'app/login/login.module#LoginModule' },
    // { path: 'login/recover',  loadChildren: 'app/login/login.module#LoginModule' },

    { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: []
})

export class AppRoutingModule {}
